/**
 * uiarc veri ızgarasının araç çubuğu düğmesi (`toolButton`): 32px, yüzeysiz; üzerine gelince/açıkken
 * `surface-muted`. Menü/popover tetikleyicileri (`aria-haspopup`) basınca küçülmez, diğerleri .96'ya iner.
 */
export const gridToolButtonClass =
  'inline-flex h-8 shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-control px-2.5 text-sm font-medium whitespace-nowrap text-text-secondary transition-[background-color,color,transform,opacity] duration-(--duration-fast) ease-standard hover:enabled:bg-surface-muted hover:enabled:text-foreground aria-pressed:bg-surface-muted aria-pressed:text-foreground data-popup-open:bg-surface-muted data-popup-open:text-foreground disabled:cursor-default disabled:opacity-40 [&:not([aria-haspopup])]:active:enabled:scale-[0.96] [&_svg]:size-4 [&_svg]:shrink-0 motion-reduce:transition-none motion-reduce:active:scale-100'

/** Araç çubuğu düğmesi üstündeki küçük sayaç hapı (uiarc `toolCount`). */
export const gridToolCountClass =
  'bg-foreground text-background inline-grid h-[18px] min-w-[18px] place-items-center rounded-pill px-[5px] text-xs leading-none tabular-nums'

/** Başlık hücresinin ortak zemini: 40px, alt çizgi, sağda ince dikey çizgi (uiarc `headCell`). */
export const gridHeadCellClass =
  'bg-surface border-border h-10 border-b p-0 text-left align-middle font-medium shadow-[inset_-1px_0_0_var(--border-subtle)]'

/** Satır numarası sütununun (uiarc `gutter`) sabit genişliği. */
export const GUTTER_WIDTH = 48
